import { jsx } from "react/jsx-runtime";
import { isMultilineAddressField } from "../../../../services/multiline-address.js";
import { InputField } from "./input-field.js";
import { NestedFormField } from "./nested-form-field.js";
import { ReadOnlyField } from "./read-only-field.js";
import { SubmitButtonField } from "./submit-button-field.js";
import { isNestedFormField, isInputField } from "../../types/form-view.js";
const FormField = ({ field, FieldLayout, ...rest }) => {
  if (!isMultilineAddressField(field) && isNestedFormField(field)) {
    return /* @__PURE__ */ jsx(NestedFormField, { ...rest, field, FieldLayout });
  }
  if (isInputField(field)) {
    return /* @__PURE__ */ jsx(InputField, { ...rest, field, FieldLayout });
  }
  if (field.fieldType === "SUBMIT_BUTTON") {
    return /* @__PURE__ */ jsx(SubmitButtonField, { ...rest, field, FieldLayout });
  }
  return /* @__PURE__ */ jsx(ReadOnlyField, { ...rest, field, FieldLayout });
};
export {
  FormField
};
//# sourceMappingURL=form-field.js.map
